import { render, staticRenderFns } from "./NodePopupCaseQuiz.vue?vue&type=template&id=1a8ee3f1"
import script from "./NodePopupCaseQuiz.vue?vue&type=script&lang=js"
export * from "./NodePopupCaseQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports